import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BaseStepComponent } from '../../base';
import { cabecalho } from 'app/entity/cabecalho-prestacao-conta.model';


@Component({
  selector: 'data-table-prestacao-conta',
  templateUrl: './data-table-prestacao-conta.component.html'
})
export class DataTablePrestacaoContaComponent  extends BaseStepComponent{
  cabecalhoDataGridAtividade: cabecalho[] = [];
  cabecalhoDataGridAtividade2: cabecalho[] = [
    { header: "Código", field: "codigo" },
    { header: "Atividade", field: "atividade" },
    { header: "Título", field: "titulo" },
    { header: "Situação", field: "situacao" }
  ];

  @Input() cabecalhoSomatorio: cabecalho[] = [];
  @Input("listaValoresAtividade") valoresDataTableAtividade: any[] = [];
  @Input("listaValoresAtividadeSomatorio") valoresDataTableAtividadeSomatorio: any[] = [];
  @Output() cabecalhoSomatorioChange: EventEmitter<any> = new EventEmitter<any>(true);
  @Input() label: string;
  @Input() listaFuncao: any[];
  @Output() emitCabecalho: EventEmitter<any> = new EventEmitter<any>(true);
  displayModal: boolean;

  gerenciamento: any;
  listaPntCFC: any[];
  listaResumo: any[];
  listaTurma: any[];
  etapa: number = 1;
  controlador: string;
  controladorVisao = true;

  init() {

    this.cabecalhoSomatorioChange.emit(this.cabecalhoSomatorio);
    this.emitCabecalho.emit();
    this.activatedRoute.params.subscribe(params => {
      let id = params['id'];
      this.service.ListarTodosGenerics("pontuacao/listarPorExercicio", { id: id }).subscribe(retorno => {
        retorno.forEach(item => {
          let items = new cabecalho;
          items.header = item.sigla;
          items.field = item.id;
          let contem = this.cabecalhoDataGridAtividade.find(x => x.field == items.field);
          if (contem == undefined) {
            this.cabecalhoDataGridAtividade.push(items);
          }
        })
      });
    });

    
  }
  verificarDado(verificador: any): boolean {
    if (verificador == "codigo" || verificador == "atividade" || verificador == "titulo" || verificador == "situacao")
      return false;
    else
      return true;
  }
  VerificarDadoTitulo(verificador: any): boolean {
    if (verificador == "titulo")
      return true;
    else
      return false;
  }

  showDialog(obj: any) {
    
  
    if (obj.atividade == "Docência") {
      this.controlador = "docencia";
    }
    else if (obj.atividade == "Evento") {
      this.controlador = "evento";
    }
    else if (obj.atividade == "Curso") {
      this.controlador = "curso";
    }
    else if (obj.atividade == "Produção Intelectual") {
      this.controlador = "producao_intelectual";
    }
    else if (obj.atividade == "Banca") {
      this.controlador = "banca";
    }
    else if (obj.atividade == "Pós Graduação") {
      this.controlador = "pos_graduacao";
    }
    else if (obj.atividade == "Curso Exterior") {
      this.controlador = "curso_exterior";
    }
    else if (obj.atividade == "Comissão") {
      this.controlador = "comissao";
    }
    this.service.ListarTodosGenerics("prestacaoConta/listarPrestacaoContaAtividade", { id_atividade: obj.id, atividade: this.controlador })
      .subscribe(retorno => {
        let element = retorno[0];
        this.listaPntCFC = element.listaPntCF;
        this.gerenciamento = element.gerenciamento;
        this.listaResumo = element.listaResumo;
        element.listTurma != undefined ? this.listaTurma = element.listTurma : [];
      });
    this.displayModal = true;
  }
  voltar(event: any) {
    this.displayModal = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/data-table-prestacao-conta/data-table-prestacao-conta.component.ts